import React from "react";
import styles from "../../../styles/brsr/general.module.css";
import { useParams } from "react-router-dom";

const GeneralInstructions = () => {
  const { id } = useParams();
  const handleRedirect = () => {
    window.location.href = `/brsr/section-a/${id}`;
  };


  return (
    <div className={styles.container}>
      {/* General Instructions Section */}
      <p className={styles.header}>GENERAL INSTRUCTIONS</p>
      <ol>
        <li className={styles.listItem}>
          <b>Read Instructions Carefully:</b>
          <p className={styles.paragraph}>
            Ensure you understand the purpose of each section and principle
            before entering data.
          </p>
        </li>
        {/* <li className={styles.listItem}>
          <b>Use Accurate Data Sources:</b>
          <p className={styles.paragraph}>
            Refer to the "Departments" sheet to identify the appropriate
            department and data source for each required data point.
          </p>
        </li> */}
        <li className={styles.listItem}>
          <b>Consistency in Data Entry:</b>
          <p className={styles.paragraph}>
            Maintain consistency in the format and units of measurement across
            all sections.
          </p>
        </li>
        <li className={styles.listItem}>
          <b>Regular Updates:</b>
          <p className={styles.paragraph}>
            Update the data regularly to ensure the most current information is
            reflected.
          </p>
        </li>
      </ol>

      {/* Section Specific Instructions */}
      <p style={{ marginTop: "3rem" }} className={styles.header}>
        SECTION SPECIFIC INSTRUCTIONS
      </p>
      <ol>
        <li className={styles.listItem}>
          <b>Section A - General Closure:</b>
          <p className={styles.paragraph}>
            Provide general information about the organization, including basic
            details like name, address, industry type, and other general
            disclosures.
          </p>
        </li>
        <li className={styles.listItem}>
          <b>Section B - Management and Process Disclosures:</b>
          <p className={styles.paragraph}>
            a. Describe the management processes and policies in place for
            sustainability and responsibility initiatives. <br />
            b. Describe governance structure &amp; any management systems used
            for tracking sustainability performance.
          </p>
        </li>
        <li className={styles.listItem}>
          <b>Section C - Principle Wise Performance Disclosure:</b>
          <p className={styles.paragraph}>
            This section is divided into nine principles. For each principle,
            provide specific data and information related to the principle's
            guidelines and performance indicators.
          </p>
        </li>
      </ol>

      {/* Continue Button */}
      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={handleRedirect}>
          Continue →
        </button>
      </div>
    </div>
  );
};

export default GeneralInstructions;
